import React from "react";
import { useQuery } from "@tanstack/react-query";
import { type DropdownMultiWithoutOptionsProps } from "../models";
import BaseMultiSelectDropdown from "./BaseMultiSelectDropdown";

interface Props extends DropdownMultiWithoutOptionsProps<server.dto.ArticleCategory> {
  section: server.dto.PromoSiteSections
}

const ArticleCategoryMultiDropdown = (props: Props) => {
  const query = useQuery({
    queryFn: async () => window.CoreApi.ArticleCategory.Paginated({ page: 1, perPage: 999 }, props.section).then(r => r.data.data),
    queryKey: ["articleCategories", props.section],
  });

  return <BaseMultiSelectDropdown
    excludeKeys={[]}
    value={props.value}
    onChange={props.onChange}
    options={query.data}
    getLabel={category => category.englishTitle}
    getValue={category => category.articleCategoryId}
    config={{
      isSearchable: true,
      shouldRenderSelectedValue: true,
      ...props.config
    }}
  />;
};

export default ArticleCategoryMultiDropdown;